import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CourseStatusForm from '../../../components/forms/CourseStatusForm';
import { useCourseStatusApi } from '../../../hooks/useCourseStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CourseStatusDTO } from '../../../services/apiClient';

const CourseStatusEdit: React.FC = () => {
  const { getById, edit, isLoading } = useCourseStatusApi();
  const [entityData, setEntityData] = useState<CourseStatusDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Course Statuses', href: '/admin/coursestatuses' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching CourseStatus data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/coursestatuses');
    } catch (error) {
      console.error('Error updating CourseStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/coursestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CourseStatus.Edit"
    >
        {entityData ? (
          <CourseStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/coursestatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CourseStatusEdit;
